/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Faq_Q4Inputs */

const en_cad_faq_q4 = /** @type {(inputs: Cad_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can I use CADCraft online without installing anything?`)
};

/**
* | output |
* | --- |
* | "Can I use CADCraft online without installing anything?" |
*
* @param {Cad_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_faq_q4 = /** @type {((inputs?: Cad_Faq_Q4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Faq_Q4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_faq_q4(inputs)
});
export { cad_faq_q4 as "cad.faq.q4" }